import {
    FETCH_NOTES_REQUEST,
    FETCH_NOTES_SUCCESS,
    FETCH_NOTES_FAILURE,
  } from "./FetchNotesTypes";
  
  const initialState = {
    loading: false,
    notesList: [],
    error: "",
  };
  
  const reducer = (state = initialState, action) => {
    switch (action.type) {
      case FETCH_NOTES_REQUEST:
        return {
          ...state,
          loading: true,
        };
      case FETCH_NOTES_SUCCESS:
        return {
          loading: false,
          notesList: action.payload,
          error: "",
        };
      case FETCH_NOTES_FAILURE:
        return {
          loading: false,
          notesList: [],
          error: action.payload,
        };
      default:
        return state;
    }
  };
  
  export default reducer;
  